import styled from 'styled-components'

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
`
